import styled, { css } from 'styled-components';
import { darken } from 'polished';
import NavItem from 'gatsby-theme-menus/src/components/nav/list-nav/nav-item';
import NavLink from 'gatsby-theme-menus/src/components/nav/list-nav/nav-link';
import activeClassName from 'gatsby-theme-menus/src/components/nav/activeClassName';

export default styled.div`
  background-color: ${({ theme }) => theme.primaryColor};
  min-height: 0.125rem;

  // className because of circular imports... :/
  .nav-list-nav {
    display: flex;

    justify-content: start;
    ${({ $navJustify }) => $navJustify === 'center' && css`
      justify-content: center;
    `}
    ${({ $navJustify }) => $navJustify === 'right' && css`
      justify-content: end;
    `}
  }

  ${NavItem} {
    &:hover {
      background-color: ${({ theme }) => darken(0.2, theme.primaryColor)};
    }
  }
  ${NavLink} {
    color: white;
    font-weight: 700;

    &.${activeClassName},
    &:hover {
      color: white;
      background-color: ${({ theme }) => darken(0.2, theme.primaryColor)};
    }
  }
`;
